/**
 * Created by akrio on 2018/3/23.
 */
import {
  CURRENT_USER_PLAN_LIST,
  CURRENT_USER_PLAN_LIST_SIMPLE,
} from "../mutation-types";
import { Plan } from "../../service/model/plan";

export default {
  state: {
    currentUserPlanList: null, // 当前所有计划
  },
  mutations: {
    [CURRENT_USER_PLAN_LIST](state, currentUserPlanList) {
      state.currentUserPlanList = currentUserPlanList;
    },
  },
  getters: {
    [CURRENT_USER_PLAN_LIST](state) {
      return state.currentUserPlanList;
    },
    [CURRENT_USER_PLAN_LIST_SIMPLE](state) {
      if (state.currentUserPlanList == null) {
        return [];
      }
      return state.currentUserPlanList.map((p) => new Plan(p));
    },
  },
};
